const styles = theme => ({
  editorButtonsRoot: {
    minWidth: '56px',
    height: '100%',
  },
})

export default styles
